import React, {useState} from 'react';
import loading from '../images/loadingblock.gif';
import confirmed from '../images/confirmed.gif';


const alertModal = () => {

  return new Promise(resolve => {

    const onClick = pass => {
      resolve(pass);
    };

    let modalY = document.getElementById('modalYes');
    modalY.addEventListener('click', onClick.bind(null, true));
    let modalN = document.getElementById('modalNo');
    modalN.addEventListener('click', onClick.bind(null, false));


    
  })


}

function ModalWindow ({modalinfo}) {

  const [mess, setMess] = useState('');
const [title, setTitle] = useState('');
const [loadimg, setLoadImg] = useState();
const [okDisabled, setOkDisabled] = useState('disabled');
const [type, setType] = useState('');


  React.useEffect(() => {
    if (modalinfo.type === 'error'){
      setTitle('Error');
      setLoadImg('');
      setOkDisabled('');
    }else if (modalinfo.type === 'info'){
        setTitle('Informational');
        setLoadImg('');
        setOkDisabled('');
    }else if(modalinfo.type === 'cancel' || modalinfo.type === 'cancelnoconf'){
      setTitle('Cancel Race');
      setLoadImg(loading);
    }else if(modalinfo.type === 'cancelconf'){
      setTitle('Cancel Race');
      setOkDisabled('');
      setLoadImg(confirmed);
    }else if(modalinfo.type === 'registerteam'){
      setTitle('Registering Team');
      setLoadImg(loading);
    }else if(modalinfo.type === 'teamregistered'){
      setTitle('Registering Team');
      setOkDisabled('');
      setLoadImg(confirmed);
    }else if(modalinfo.type === 'setroles'){
      setTitle('Setting Roles');
      setLoadImg(loading);
    }else if(modalinfo.type === 'roleset'){
      setTitle('Roles Set');
      setOkDisabled('');
      setLoadImg(confirmed);
        }else if(modalinfo.type === 'setmanagestyle'){
      setTitle('Setting Management Style');
      setLoadImg(loading);
    }else if(modalinfo.type === 'managestyleset'){
      setTitle('Management Style Set');
      setOkDisabled('');
      setLoadImg(confirmed);
            }else if(modalinfo.type === 'sethydrolyte'){
      setTitle('Assigning Hydrolyte');
      setLoadImg(loading);
    }else if(modalinfo.type === 'hydrolyteset'){
      setTitle('Hydrolyte Assigned.');
      setOkDisabled('');
      setLoadImg(confirmed);
    }else if(modalinfo.type === 'awasendcounter'){
      setTitle('Send Counter');
      setLoadImg(loading);
    }else if(modalinfo.type === 'countersent'){
      setTitle('Send Counter');
      setOkDisabled('');
      setLoadImg(confirmed);}
      else if(modalinfo.type === 'accstart'){
        setTitle('Update Account Name');
        setLoadImg(loading);
    }else if(modalinfo.type === 'accupdated'){
        setTitle('Update Account Name');
        setOkDisabled('');
        setLoadImg(confirmed);
    }else if(modalinfo.type === 'abbstart'){
      setTitle('Update Team Abbreviation');
      setLoadImg(loading);
  }else if(modalinfo.type === 'abbupdated'){
      setTitle('Update Team Abbreviation');
      setOkDisabled('');
      setLoadImg(confirmed);
  }else if(modalinfo.type === 'upstart'){
          setTitle('Update Transfer Status');
          setLoadImg(loading);
    }else if(modalinfo.type === 'upsupdated'){
      setTitle('Update Transfer Status');
      setOkDisabled('');
      setLoadImg(loading);
}else if(modalinfo.type === 'addfavestart'){
  setTitle('Adding Favorite Status');
  setLoadImg(loading);
}else if(modalinfo.type === 'faveadded'){
setTitle('Adding Favorite Status');
setOkDisabled('');
setLoadImg(loading);
}else if(modalinfo.type === 'remfavestart'){
  setTitle('Removing Favorite Status');
  setLoadImg(loading);
}else if(modalinfo.type === 'faveremoved'){
setTitle('Removing Favorite Status');
setOkDisabled('');
setLoadImg(loading);
}else if(modalinfo.type === 'pearlmess'){
      setTitle('Pearl Approval');
      setLoadImg(loading);
  }else if(modalinfo.type === 'balanceset'){
      setTitle('Pearl Approval');
      setOkDisabled('');
      setLoadImg(confirmed);
  }else if(modalinfo.type === 'nftmess'){
    setTitle('NFT Approval');
    setLoadImg(loading);
}else if(modalinfo.type === 'approvalset'){
    setTitle('NFT Approval');
    setOkDisabled('');
    setLoadImg(confirmed);
}else if(modalinfo.type === 'nftmint'){
  setTitle('NFT Mint');
  setLoadImg(loading);
}else if(modalinfo.type === 'nftmintcomp'){
  setTitle('NFT Mint');
  setOkDisabled('');
  setLoadImg(confirmed);
}else if(modalinfo.type === 'unreg'){
  setTitle('Unregister Racers');
  setLoadImg(loading);
}else if(modalinfo.type === 'unregconfirm'){
  setTitle('Unregister Racers');
  setOkDisabled('');
  setLoadImg(confirmed);
}else if(modalinfo.type === 'move'){
  setTitle('Move Racers');
  setLoadImg(loading);
}else if(modalinfo.type === 'movecomp'){
  setTitle('Move Racers');
  setOkDisabled('');
  setLoadImg(confirmed);
}else if(modalinfo.type === 'transfernft'){
  setTitle('Transfering NFTS');
  setLoadImg(loading);
}else if(modalinfo.type === 'nftstransfered'){
  setTitle('Transfering NFTS');
  setOkDisabled('');
  setLoadImg(confirmed);
}else if(modalinfo.type === 'loadingracers'){
  setTitle('Loading Account Info');
  setLoadImg(loading);
}

    setMess(modalinfo.message);
    setType(modalinfo.type);
  },[modalinfo])

  return (
    <div className="modal fade" id="showAlerts" tabIndex="-1" aria-labelledby="showSingleLabel"  data-bs-backdrop="static" 
        data-bs-keyboard="false" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered">
<div className="modal-content rounded-4 shadow">
  <div className="modal-header border-bottom-0">
    <h5 className="modal-title">{title}</h5>
    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  </div>
  <div className="modal-body py-0">
    <p><img src={loadimg} alt={'alert'} style={{width:'60%', height:'50%', display : (loadimg === '' ? 'none' : 'block')}}/>{mess}</p>
  </div>
  <div className="modal-footer flex-column border-top-0">
    <button type="button" className="btn btn-lg btn-light w-100 mx-0" style={{display:(type === 'cancel' ? 'none' : 'inline')}}  data-bs-dismiss="modal" disabled={okDisabled}>Close</button>
    <button type="button" className="btn btn-lg btn-light w-100 mx-0" style={{display:(type === 'cancel' ? 'inline' : 'none')}} id="modalNo" data-bs-dismiss="modal">No</button> <button type="button" className="btn btn-lg btn-light w-100 mx-0" id="modalYes" style={{display:(type === 'cancel' ? 'inline' : 'none')}}>Yes</button>
  </div>
</div>
</div>
</div>
)
}

export {alertModal, ModalWindow};